import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { LogoTextProps as Props } from './types';

export const LogoText = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper className={classnames('LogoText', className)} sx={SX.root}>
      <Typography variant="body2" color="primary.500" fontWeight={900}>
        AI
      </Typography>
      <Typography variant="body2" color="common.black" fontWeight={900}>
        Ark
      </Typography>
    </Styled.Wrapper>
  );
});

LogoText.displayName = 'LogoText';
